module.exports = __webpack_public_path__ + "media/images/pages/i-belong/faces-a1d482431d2c94bc4b59c6414b55dcfe.png";